<template>
  <div class="column is-12-mobile is-6-tablet is-4-desktop">
    <div
      class="card"
      @click="() => { openLink(item['@path']); }"
    >
      <div
        data-aos="zoom-in"
        class="aos-init aos-animate h-full"
      >
        <div class="card--img bordered">
          <div
            v-if="item?.categories"
            class="featured-wrapper"
          >
            <div
              v-for="(category, index) in item.categories"
              :key="'category' + index"
              class="featured-ribbon category"
              :class="['category-' + category.replace(/\s+/g, '-').toLowerCase()]"
            >
              {{ category }}
            </div>
          </div>
          <img
            class="blog-image"
            alt="project"
            :src="WEB_HOME_URL + (item.imagePath)"
          >
        </div>
        <div class="card-text p-4 relative">
          <div class="card---content">
            <div class="divider" />
            <div
              v-sane-html="highlightText(searchText, item.title)"
              class="h5 my-2"
            />
            <div
              v-sane-html="highlightText(searchText, item.pageDescription)"
              class="text-ellipsis line4 mb-2"
            />
            <div
              v-if="item.collaborator"
              class="text-ellipsis line3 mb-2"
            >
              <strong>{{ $t("project.list.collaborator") }} </strong>: <span>{{ item.collaborator }} </span>
            </div>
          </div>
          <div>
            <div v-if="item.progressStatus">
              <strong>{{ $t("project.list.progressStatus") }}</strong>: <span
                :class="{
                  'category-in-process': item.progressStatus === 'In Progress',
                  'category-completed': item.progressStatus === 'Completed'
                }"
              >{{ item.progressStatus }}</span>
            </div>
            <a
              class="button is-brightGreen is-inverted svg nav-arrow-green-15 arrow right sink-bottom-left static-position"
              :href="item['@path']"
              aria-label="visit detail page"
            >
              {{ $t("project.list.seeDetail") }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ProjectItemType } from '@/composables/state/projectSearchApp';

import { PropType, defineProps } from 'vue';
import { highlightText, openLink } from '@/config/common';

// const props =
defineProps({
  item: { type: Object as PropType<ProjectItemType>, default: () => { return {}; } },
  defaultImageUrl: { type: String, default: '' },
  childPageUrl: { type: String, default: '' },
  searchText: { type: String as PropType<string | null>, default: '' },
  isListMode: { type: Boolean, default: false }
});

// const categoryClass = computed(() => {
//   if (!props.item?.categories) return '';
//   const categories = props.item.categories.replace(/\s+/g, '-').toLowerCase(); // Replace spaces with dashes and make lowercase
//   return `category-${categories}`;
// });
// const searchAuthor = (author:string) => {
//   window.location.href =
//         window.location.protocol + '//' +
//         window.location.host +
//         window.location.pathname +
//         '?author=' + author;
// };

// const openLink = (link:string) => {
//   window.open(link);
// };
const WEB_HOME_URL = (import.meta.env.VITE_APP_HOME_URL ?? '');

</script>

<style scoped>
.description {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.pub-image {
  width: 100%;
  height: 100%;
  background-size: cover;
  min-height:250px;
  background-position: center;
}
.text-ellipsis{
  text-overflow:ellipsis;
  overflow:hidden;
  display: -webkit-box !important;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  white-space: normal;
}
.text-ellipsis-1{
  text-overflow:ellipsis;
  overflow:hidden;
  display: -webkit-box !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
}

.category-in-process {
  color: #b0bf49;
}

.category-completed {
  color: grey;
}

.category-bioacoustics {
  background-color: #E36262
}
.category-caribou {
  background-color: #b591b6 !important;
}
.category-taxonomy {
  background-color: #e3a863 !important;
}
.category-environmental-monitoring {
  background-color: #88adcf !important;
}

.category-environmental-sensors {
  background-color: #91B1B6 !important;
}

.category-ecosystem-services {
  background-color: #B6A991 !important;
}

.category-community-of-practice {
  background-color: #91B3B6 !important;
}

.category-climate-change {
  background-color: #8F654E!important;
}
.category-remote-sensing{
  background-color: #B69E91 !important;
}

.category-citizen-science{
  background-color: #514E8F !important;
}

.category-wildlife-monitoring{
  background-color: #AAB691 !important;
}

.category-monitoring{
  background-color: #a6c89a !important;
}

.category-habitat-recovery{
  background-color: #4E728F!important;
}

.category-dna {
  background-color: #4E8F77 !important;
}

.category-methods-development {
  background-color: #8F4E4E !important;
}

.category-geospatial {
  background-color: #91B69B!important;
}

.category-landscape-ecology {
  background-color: #B691AB !important;
}

</style>
